module.exports = __webpack_public_path__ + "static/media/Questrial-Regular.7775b2ab.ttf";